import { useEffect, useState } from "react";
import styles from "./ResultadoAnalise.module.css";
import { ptBR } from "date-fns/locale";
import { format, parse } from "date-fns";
import { Alert, Box, CircularProgress, FormControl, Modal, Snackbar } from "@mui/material";
import { WhiteInput } from "../../../components/Inputs/InputText";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { ModalStyle } from "../../../components/Popup/ModalStyle";

const ResultadoAnalise = ({ setOpen, record }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openErrorWindow, setOpenErrorWindow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [situacaoTexto, setSituacaoTexto] = useState("");

  useEffect(() => {
    if (!record) return;

    let txtSituacao = "";

    switch (record?.SituacaoFiscalizacao) {
      case 1:
        txtSituacao = "Aguardando análise"
        break;
      case 2:
        txtSituacao = "Revisar solicitação"
        break;
      case 4:
        txtSituacao = "Fiscalização solicitada"
        break;
      case 5:
        txtSituacao = "Fiscalização reprovada"
        break;
      case 6:
        txtSituacao = "Concluído"
        break;
      case 7:
        txtSituacao = "Cancelada"
        break;
      case 8:
        txtSituacao = "Arquivada"
        break;
      default:
        break;
    }

    setSituacaoTexto(txtSituacao);
  }, [record]);

  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenErrorWindow(false);
    }

    setOpenErrorWindow(false);
  }

  return (
    <div style={{ width: "100%", minWidth: 600, height: "100%" }}>
      {(record && record?.Id) && (
        <div>
          <header className={styles.header}>
            <span className={styles.headerData}>
              <div className={styles.dateBox}></div><b>Data de apresentação: </b> {
                record?.DataApresentacao?.includes("01/01/1900") ?
                  "Data ainda não definida" :
                  format(parse(record?.DataApresentacao, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                    locale: ptBR
                  })
              }
            </span>
          </header>

          <header className={styles.header}>
            <span className={styles.headerData}>
              <div className={`${styles.dateBox} ${styles['dateBox-orange']}`}></div><b>Prazo da análise: </b> {
                record?.PrazoAnalise?.includes("01/01/1900") ?
                  "Data ainda não definida" :
                  format(parse(record?.PrazoAnalise, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                    locale: ptBR
                  })
              }
            </span>
          </header>

          <header className={styles.header}>
            <span className={styles.headerData}>
              <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data de conclusão: </b>{
                record?.DataConclusao?.includes("01/01/1900") ?
                  "Data ainda não definida" :
                  format(parse(record?.DataConclusao, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                    locale: ptBR
                  })
              }
            </span>
          </header>
        </div>
      )}

      <div className={styles.situacaoAnalise}>
        <div className={styles.resultadoAnaliseParcial}
        >

          <h3>Resultado</h3>
          <div className={styles.parecerSituacao}>
            Situação:  {situacaoTexto}
          </div>
        </div>

        <div className={styles.descricao}>
          <strong style={{ display: "block" }}>Parecer da análise:</strong>
          <FormControl variant="outlined" style={{ width: "100%" }}>
            <WhiteInput
              style={{ color: "#B8B8B8" }}
              fullWidth
              type="text"
              minRows={4}
              multiline
              value={record?.ParecerAnalise}
              readOnly={true}
            />
          </FormControl>
        </div>
      </div>

      <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Modal open={isLoading}>
        <Box style={ModalStyle}>
          <CircularProgress color="inherit" />
        </Box>
      </Modal>
    </div>
  )
}

export { ResultadoAnalise }